// main.jsx
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Debug logging
console.log('🚀 React app starting...');
console.log('Environment:', import.meta.env.MODE);
console.log('Build time:', new Date().toLocaleString());

// Ensure the root element exists
const rootElement = document.getElementById('root');

if (!rootElement) {
  // Create root element if it doesn't exist
  const newRoot = document.createElement('div');
  newRoot.id = 'root';
  document.body.appendChild(newRoot);
}

try {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('✅ React app rendered successfully!');
} catch (error) {
  console.error('❌ React app failed to render:', error);
  
  // Show error in DOM
  const errorElement = document.getElementById('root') || document.body;
  errorElement.innerHTML = `
    <div style="
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 40px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
    ">
      <div style="max-width: 800px; background: rgba(0,0,0,0.8); padding: 40px; border-radius: 20px; backdrop-filter: blur(10px);">
        <h1 style="color: #ff3860; font-size: 2.5rem; margin-bottom: 20px;">🚨 React Application Error</h1>
        <div style="background: #1a1a1a; padding: 25px; border-radius: 10px; overflow: auto; margin-bottom: 25px; font-size: 14px;">
          <strong>Error Message:</strong><br/>
          <code style="color: #ff6b6b;">${error.toString()}</code>
          ${error.stack ? `<br/><br/><strong>Stack Trace:</strong><br/><code style="color: #ccc;">${error.stack}</code>` : ''}
        </div>
        <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 15px; margin-bottom: 25px;">
          <button onclick="window.location.reload()" style="
            background: #4299e1;
            color: white;
            border: none;
            padding: 15px;
            border-radius: 8px;
            cursor: pointer;
            font-weight: bold;
          ">🔄 Refresh Page</button>
          <button onclick="console.clear(); console.error('${error.toString()}');" style="
            background: #ed8936;
            color: white;
            border: none;
            padding: 15px;
            border-radius: 8px;
            cursor: pointer;
            font-weight: bold;
          ">📋 Copy Error to Console</button>
        </div>
        <p style="color: #a0aec0; font-size: 0.9rem;">
          Check browser console (F12) for detailed error information.<br/>
          If this persists, please check your React component code.
        </p>
      </div>
    </div>
  `;
}